module.exports = __webpack_public_path__ + "static/day04-e53a5d5eb0df4b84a414d453aa9dbb62.png";